<script setup lang="ts">
import { ref, onMounted } from "vue";
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
import { getSmallestThumbnailUrl } from "@shopware-pwa/helpers-next";

const props = defineProps<{
  news: any;
}>();
const news = computed(() => props.news);

function getThumbnailUrl(media: any) {
  if (media.thumbnails?.length > 0) {
    let thumb = `${getSmallestThumbnailUrl(media)}`;
    if (thumb) {
      return thumb;
    }
  }
  return `${media.url}`;
}

function formatDate(data: string) {
  if (data) {
    const date = new Date(data); // Parse the input date string
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const year = date.getFullYear(); // Get the full year

    return `${day}/${month}/${year}`;
  }
}
</script>

<template>
  <div class="product product-wrap relative">
    <div class="prod-img mb-4">
      <NuxtLink
        :to="
          news.slug
            ? formatLink(`/blog/` + news.slug.replace(/ /g, '-'))
            : formatLink(`/news/blog/${news.id}`)
        "
      >
        <figure
          class="flex items-center justify-center truncate rounded-lg h-auto w-full md:h-[184px] md:w-[285px]"
        >
          <NuxtImg
            v-if="news.image?.url"
            class="w-full h-full rounded-lg hover:scale-105 transition duration-300"
            format="webp"
            :src="getThumbnailUrl(news.image)"
            width="285"
            height="184"
            loading="lazy"
          />
          <img
            v-else
            src="assets/images/placeholder-product.png"
            alt="Placeholder image"
            class="w-full h-full rounded-lg hover:scale-105 transition duration-300"
          />
        </figure>
      </NuxtLink>
    </div>
    <div class="product-detail">
      <NuxtLink
        :to="
          news.slug
            ? formatLink(`/blog/` + news.slug.replace(/ /g, '-'))
            : formatLink(`/news/blog/${news.id}`)
        "
        class="hover:text-red-bg transition duration-300"
        ><h6 class="text-base font-bold mb1.5 line-clamp-1">
          {{ news.translated.title }}
        </h6>
      </NuxtLink>
      <p class="text-sm font-normal line-clamp-2 mb-4" v-if="news.contents">
        {{ news.contents.replace(/<[^>]*>/g, "").substring(0, 100) }}
      </p>
      <div class="authore-detail flex items-center">
        <div class="post-detail flex items-center mr-5">
          <div class="date">
            <span class="text-xs font-semibold leading-normal text-davy-grey">{{
              formatDate(news.postdate) || formatDate(news.createdAt)
            }}</span>
          </div>
        </div>
        <div class="read">
          <span
            class="text-xs font-semibold leading-normal text-davy-grey relative"
            >{{ news.author?.name }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
